import { Team } from '@cbinsights/adminservice/adminservice';
import { Avatar, Card, List, Pagination, Tag } from 'antd';
import Meta from 'antd/lib/card/Meta';
import { avatarText } from 'client/modules/permissions/components/PermissionsListLinkCard';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { DataFeedRoutes } from '../routesHelper';

export const TeamList = ({
  isLoadingTeams,
  teams,
}: {
  isLoadingTeams: boolean;
  teams: Team[];
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const paginatedTeams = (teams || []).slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [teams.length]);

  return (
    <div>
      <List
        loading={isLoadingTeams}
        itemLayout="horizontal"
        dataSource={paginatedTeams}
        renderItem={(team) => {
          const avatar = (
            <Avatar key={`${team.name}-${team.idTeam}`} size={50}>
              {avatarText(team.name)}
            </Avatar>
          );
          return (
            <List.Item key={team.idTeam}>
              <Link
                to={`${DataFeedRoutes.DataFeed}/${team.idTeam}`}
                style={{ width: '100%' }}
              >
                <Card bodyStyle={{ padding: 16 }}>
                  <Meta
                    avatar={avatar}
                    title={team.name}
                    description={<Tag>Team ID: {team.idTeam}</Tag>}
                  />
                </Card>
              </Link>
            </List.Item>
          );
        }}
      />
      <div className="flex justify-center mb-4">
        <Pagination
          showSizeChanger
          onShowSizeChange={(_, size) => {
            setCurrentPage(1);
            setPageSize(size);
          }}
          current={currentPage}
          pageSize={pageSize}
          total={teams.length}
          onChange={handlePageChange}
        />
      </div>
    </div>
  );
};
